import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { loggedIn, logout, logOutAdmin } from '../../../SuperAdminLogin/actions/superAdminLoginAction'
import SettingsHeartRunnerComponent from '../components/settingsHeartRunnerComponent';
import {syncUser,insertAlarmJSON,abortMissionAlarm, syncSetting, syncKitLocationOnDispatcher, getAutoSynchronizationUserTime,
    updateAutoSynchronizationUserTimeFunc} from '../actions/settingsHeartRunnerAction'; 

class SettingsHeartRunnerContainer extends Component {
    constructor(props) {
        super(props);
 
    }

    componentWillMount() {
       /* if (this.props.login.authTokenId !== undefined || this.props.login.authTokenId !== "") {
            if (loggedIn(this.props.login.authTokenId)) {*/
              
            /*}
            else {
                logout();
                this.props.actions.logOutAdmin();
                this.props.history.push('/adminLogin');
            }
        }
        else {
            logout();
            this.props.history.push('/adminLogin');
        }*/
    } 
    componentDidMount() {
        this.props.actions.getAutoSynchronizationUserTime(
        this.props.dispatch)
    }
    syncUser=()=>{
        this.props.actions.syncUser(            
            this.props.dispatch
        )
    }
    syncSetting=()=>{
        this.props.actions.syncSetting(            
            this.props.dispatch
        )
    }
    syncLocation = () => {
        this.props.actions.syncKitLocationOnDispatcher(
            this.props.dispatch
        )
    }
    insertAlarmJSON=(data)=>{
        this.props.actions.insertAlarmJSON(            
            data,
            this.props.dispatch
        )
    }
    abort=(id) =>{
        this.props.actions.abortMissionAlarm(
            id,
            this.props.dispatch
        )
    }
    updateSyncTime = (data) => {
        this.props.actions.updateAutoSynchronizationUserTimeFunc(
            data,
            this.props.dispatch
        )
    }
    render() {
        
        return (
            <div className="agile-grids">           
                <div className="grids">
                    <div className="container">
                        <div className="row">
                            <SettingsHeartRunnerComponent  syncUser={this.syncUser}
                                syncSetting = {this.syncSetting}
                                syncLocation = {this.syncLocation}
                                insertAlarmJSON={this.insertAlarmJSON} 
                                details={this.props.details}
                                abortAlarmMission={this.abort}
                                updateSyncTimeData = {this.updateSyncTime}
                            />
                        </div>
                    </div>
                </div>
                
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            logOutAdmin, 
            syncUser,
            syncSetting,
            syncKitLocationOnDispatcher,
            insertAlarmJSON,
            abortMissionAlarm,
            getAutoSynchronizationUserTime,
            updateAutoSynchronizationUserTimeFunc
        }, dispatch)
    };
};

function mapStateToProps({  superAdminLoginReducer, settingsHeartRunnerReducer }) {      
    return {
        details: {
            isLoadingSyncLocation : settingsHeartRunnerReducer.isLoadingSyncLocation,
            isLoadingSetting : settingsHeartRunnerReducer.isLoadingSetting, 
            isLoadingSyncUser : settingsHeartRunnerReducer.isLoadingSyncUser,
            isLoadingAbortMission : settingsHeartRunnerReducer.isLoadingAbortMission,
            isLoading: settingsHeartRunnerReducer.isLoading, 
            messageLabel: settingsHeartRunnerReducer.messageLabel,
            errorNumber: settingsHeartRunnerReducer.errorNumber,
            errorMessage: settingsHeartRunnerReducer.errorMessage,
            statusCode:settingsHeartRunnerReducer.statusCode,
            isLoadingSyncUserTime : settingsHeartRunnerReducer.isLoadingSyncUserTime,
            autoSyncUserTime : settingsHeartRunnerReducer.autoSyncUserTime
        },
        login: {
            authTokenId: superAdminLoginReducer.authTokenId,
            adminId: superAdminLoginReducer.adminId,
            organizationId: superAdminLoginReducer.organizationId
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SettingsHeartRunnerContainer))